module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_landing) ? _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.site_view == 1) ? _c('div', [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background-color": "none",
      "margin-top": "3.8em",
      "padding": "0.5em",
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0.8em",
      "margin-top": "1em",
      "margin-bottom": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container-x",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-1.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.set_categories), function(data, index) {
    return _c('li', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('p', [_vm._v(_vm._s(data.category_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0.8em",
      "margin-top": "-2.5em"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.set_categories), function(data, index) {
    return _c('li', {
      staticStyle: {
        "width": "85%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "180px",
        "margin": "0",
        "padding": "0.31em"
      },
      style: ('backgroundColor:' + data.category_color)
    }, [_c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('p', [_vm._v(_vm._s(data.category_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  }), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "8em",
      "padding": "0.8em",
      "margin-top": "-2.5em",
      "background-color": "#f9f9f9"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "padding": "8px"
      }
    }, [_c('div', {
      staticClass: "card-col-pr"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "pr-top",
      staticStyle: {
        "padding": "0.5em"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "75%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "height": "30px",
        "width": "30px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-img-boxx-x"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "card-col-pr-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "card-col-pr-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0.8em",
        "padding-top": "0.0em"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "85%"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bolder",
        "margin-top": "-0px"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))]), _vm._v(" "), _c('p', {
      staticClass: "pr-name-1-lines",
      staticStyle: {
        "margin-top": "-0.25em",
        "line-height": "0.8",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container-x",
    staticStyle: {
      "background-color": "none",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row-x"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "1em 0.8em",
      "padding": "2em 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0.2em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2"
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(data.category_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": data.category_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (product.product_images.length > 0) ? _c('div', {
      staticClass: "card-col-2c"
    }, [_c('div', {
      staticClass: "card col-xs-6"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/make/order/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-col-2c-img",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "contain"
      },
      style: ({
        'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.247), rgba(8, 8, 8, 0.211)),' + 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "card-badge"
    }, [_c('div', {
      staticClass: "container",
      staticStyle: {
        "background": "#ffffff"
      }
    }, [_c('h6', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('span', [_vm._v(_vm._s(product.product_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-transform": "capitalize",
        "font-size": "22px"
      }
    }, [_c('b', [_vm._v(_vm._s(product.product_business_ownername))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _vm._m(12, true)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {}, [_c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(13, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.businesses), function(business) {
    return _c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/' + business.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-colxx",
      staticStyle: {
        "margin-bottom": "-1em",
        "z-index": "5"
      }
    }, [_c('img', {
      staticClass: "card-col-img",
      attrs: {
        "src": business.business_brand_image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "height": "75px",
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "1.6em"
      }
    }, [_c('p', [_vm._v(_vm._s(business.business_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "100vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "100vh",
      "padding": "2em",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderAddons'
      }
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderCheckout'
      }
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order List")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "128%"
    }
  }, _vm._l((_vm.set_order_list), function(item, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(item.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'sub', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'add', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_vm._m(16, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderAddons') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_vm._m(18, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setOrderCheckout"
    }
  }, [(_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(19), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                          " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                        ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(20), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                          Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(21), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                          Pay to Direct")]), _vm._v(" "), _vm._m(22)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "background-color": "#ffffff",
      "bottom": "0",
      "width": "100%",
      "padding-left": "1.81em",
      "padding-top": "6px",
      "margin-top": "10px",
      "border-top": "1px solid #eee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.set_view_box == 'setPaymentOptions') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])])]) : (_vm.set_view_box == 'setContactDetails') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setPaymentOptions'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0em",
      "margin": "0",
      "padding": "0 2em",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "x-cta-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox');
      }
    }
  }, [_vm._v("Order Now>>")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('component-footer')], 1) : _c('div', [_c('component-desktop')], 1)]) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 10px",
      "margin-top": "0em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "75%"
    }
  }, [_c('h5', [_vm._v("Location . Awka")]), _vm._v(" "), _c('p', {
    staticClass: "pr-name-1-lines",
    staticStyle: {
      "margin-top": "-0.81em",
      "font-size": "12px"
    }
  }, [_vm._v("Munchit, Trust Hotel, near Aroma Secretarait Junction")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "25%",
      "padding-left": "1em",
      "padding-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "border-radius": "10px",
      "background-color": "#5703a5",
      "color": "#ffffff",
      "line-height": "0.8"
    }
  }, [_vm._v("Change")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 0.2em",
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 mp0",
    staticStyle: {
      "padding": "0 8px"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#421A7A",
      "border-radius": "8px",
      "padding": "0.4em 0.8em",
      "padding-bottom": "0",
      "color": "#ffffff"
    }
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "width": "65%",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Last "), _c('br'), _vm._v("Shopping")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "35%",
      "margin-top": "0.46em",
      "margin-bottom": "0em",
      "padding-left": "0.12em"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag",
    staticStyle: {
      "font-size": "3.4em",
      "margin-top": "-0.46em",
      "margin-left": "0.3em",
      "color": "#e68f74"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-shopping-bag",
    staticStyle: {
      "font-size": "3.0em",
      "margin-top": "-1.46em",
      "color": "#ebb1a2"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 mp0",
    staticStyle: {
      "padding": "0 8px"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#421A7A",
      "border-radius": "8px",
      "padding": "0.4em 0.8em",
      "padding-bottom": "0",
      "color": "#ffffff"
    }
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "width": "65%",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Saved "), _c('br'), _vm._v("Shops")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-store",
    staticStyle: {
      "float": "right",
      "width": "35%",
      "font-size": "3.4em",
      "margin-top": "0.46em",
      "margin-bottom": "0em",
      "padding-left": "0.12em",
      "color": "#e68f74"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0.5em",
      "margin-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#eee2fd",
      "border-radius": "12px",
      "padding": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "65%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12",
      "color": "#333"
    }
  }, [_vm._v("Premium offer")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "800",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Create your"), _c('br'), _vm._v("Shopping List")]), _vm._v(" "), _c('p', [_vm._v("excellent offers await you")]), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "border-radius": "10px",
      "background-color": "#5703a5",
      "color": "#ffffff",
      "line-height": "0.8"
    }
  }, [_vm._v("Change")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "35%"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "3em"
    },
    attrs: {
      "src": "/static/assets/images/shopping-bags.webp"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Shop by category")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-square",
    staticStyle: {
      "padding": "1em",
      "background-color": "#f3f3f3"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("Near By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-square",
    staticStyle: {
      "padding": "1em",
      "background-color": "#f3f3f3"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_c('h4', {
    staticStyle: {
      "float": "left",
      "font-weight": "800"
    }
  }, [_vm._v("Top Picks")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Select / Filter")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "25%",
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "font-size": "14px",
      "color": "#f5e50a"
    }
  }), _vm._v(" 4.5\r\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "15%",
      "padding-top": "8px"
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag",
    staticStyle: {
      "font-size": "22px",
      "color": "#949393"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "1em 0.8em",
      "padding": "2em 1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card col-xs-6"
  }, [_c('a', {
    staticClass: "card-link"
  }, [_c('div', {
    staticClass: "card-col-2c-img",
    staticStyle: {
      "background": "#750647",
      "background-repeat": "no-repeat",
      "background-size": "contain"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card col-xs-6"
  }, [_c('a', {
    staticClass: "card-link"
  }, [_c('div', {
    staticClass: "card-col-2c-img",
    staticStyle: {
      "background": "#750647",
      "background-repeat": "no-repeat",
      "background-size": "contain"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "htro"
  }, [_c('h3', [_vm._v("\r\n                Trending\r\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f7df2b",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.62em 0.81em"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "1.3em"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "htro"
  }, [_c('h3', [_vm._v("\r\n                  in stock\r\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c663ed78"}!./src/pages/Timeline/template.html
// module id = 628
// module chunks = 0